import { Notification, ApiResponse } from '@court-sync/shared';
import { apiGet, apiPut } from './apiClient';

export interface NotificationListResponse {
  notifications: Notification[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const notificationService = {
  async getNotifications(page: number = 1, limit: number = 20): Promise<ApiResponse<NotificationListResponse>> {
    return apiGet<NotificationListResponse>('/notifications/history', {
      params: { page, limit },
    });
  },

  async getUnreadCount(): Promise<number> {
    try {
      const response = await apiGet<NotificationListResponse>('/notifications/history', {
        params: { page: 1, limit: 100 },
      });

      if (response.success && response.data) {
        const notifications = response.data.notifications || [];
        return notifications.filter((n: Notification) => !n.isRead).length;
      }
      return 0;
    } catch (error) {
      console.error('Error getting unread count:', error);
      return 0;
    }
  },

  async markAsRead(notificationId: string): Promise<ApiResponse> {
    return apiPut(`/notifications/mark-read/${notificationId}`);
  },

  async markAllAsRead(): Promise<ApiResponse> {
    const notifications = await this.getNotifications(1, 100);
    if (notifications.success && notifications.data) {
      const unread = notifications.data.notifications.filter(n => !n.isRead);
      await Promise.all(unread.map(n => this.markAsRead(n.id)));
    }
    return { success: true };
  },
};
